"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogEntries = void 0;
const typeorm_1 = require("typeorm/browser");
const account_1 = require("./account");
const contact_1 = require("./contact");
let LogEntries = class LogEntries {
};
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
    }),
    __metadata("design:type", String)
], LogEntries.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamptz',
        nullable: true,
        default: () => 'now()',
    }),
    __metadata("design:type", Date)
], LogEntries.prototype, "timeStamp", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        nullable: true,
    }),
    __metadata("design:type", String)
], LogEntries.prototype, "userId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => account_1.Account, { createForeignKeyConstraints: false }),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", account_1.Account)
], LogEntries.prototype, "user", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 18,
    }),
    __metadata("design:type", String)
], LogEntries.prototype, "adminId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_1.Contact, { createForeignKeyConstraints: false }),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", contact_1.Contact)
], LogEntries.prototype, "admin", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 18,
    }),
    __metadata("design:type", String)
], LogEntries.prototype, "job", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
    }),
    __metadata("design:type", String)
], LogEntries.prototype, "jobApiId", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
    }),
    __metadata("design:type", String)
], LogEntries.prototype, "newStatus", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
    }),
    __metadata("design:type", String)
], LogEntries.prototype, "jobCancellationId", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'jsonb',
        nullable: true,
    }),
    __metadata("design:type", Object)
], LogEntries.prototype, "oldValues", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'jsonb',
        nullable: true,
    }),
    __metadata("design:type", Object)
], LogEntries.prototype, "newValues", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
    }),
    __metadata("design:type", String)
], LogEntries.prototype, "eventType", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
    }),
    __metadata("design:type", String)
], LogEntries.prototype, "source", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
    }),
    __metadata("design:type", String)
], LogEntries.prototype, "targetTable", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({
        type: 'int8',
        nullable: true,
        name: 'txid',
        default: () => 'txid_current()',
    }),
    __metadata("design:type", String)
], LogEntries.prototype, "transactionId", void 0);
LogEntries = __decorate([
    (0, typeorm_1.Entity)('log_entries', { schema: 'public' })
], LogEntries);
exports.LogEntries = LogEntries;
//# sourceMappingURL=log-entries.js.map